(function () {
  "use strict";
  var TOOLS = {
    ptt: "d32_tool_ptt",
    tcis: "d32_tool_tcis",
    antenna: "d32_tool_antenna",
    chart: "d32_tool_chart"
  };
  var LABELS = {
    ptt: "PTT",
    tcis: "Full kit",
    antenna: "Antenna",
    chart: "Radio plug"
  };

  function sectionEl(suffix) {
    var nodes = document.querySelectorAll('[id*="__' + suffix + '"]');
    return nodes.length ? nodes[0] : null;
  }

  function setMode(mode, push) {
    mode = (mode || "ptt").toLowerCase();
    if (!TOOLS[mode]) mode = "ptt";
    document.body.classList.add("d32-syscfg-page");

    Object.keys(TOOLS).forEach(function (key) {
      var el = sectionEl(TOOLS[key]);
      if (el) el.style.display = key === mode ? "" : "none";
    });

    document.querySelectorAll(".d32-syscfg__tab").forEach(function (btn) {
      var on = btn.getAttribute("data-d32-mode") === mode;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
    });

    document.querySelectorAll(".d32-syscfg__select").forEach(function (sel) {
      if (sel.value !== mode) sel.value = mode;
    });

    if (push) {
      try {
        history.replaceState(null, "", window.location.pathname + "?mode=" + mode);
      } catch (e) {}
    }

    // Scroll tools into view only if header is far above (avoid jump on load)
    if (push) {
      var head = document.querySelector(".d32-syscfg");
      if (head) {
        var y = head.getBoundingClientRect().top + window.pageYOffset - 8;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }

  function fromUrl() {
    try {
      var u = new URL(window.location.href);
      var m = (u.searchParams.get("mode") || (u.hash || "").replace("#", "") || "ptt").toLowerCase();
      if (m === "full-kit" || m === "kit" || m === "full") m = "tcis";
      if (m === "connectors" || m === "plug" || m === "connector") m = "chart";
      if (m === "ark" || m === "relocation") m = "antenna";
      if (m === "match" || m === "ptt-match") m = "ptt";
      return m;
    } catch (e) {
      return "ptt";
    }
  }

  function boot() {
    document.body.classList.add("d32-syscfg-page");

    // Hide non-default tools immediately
    Object.keys(TOOLS).forEach(function (key) {
      if (key === "ptt") return;
      var el = sectionEl(TOOLS[key]);
      if (el) el.style.display = "none";
    });

    document.querySelectorAll(".d32-syscfg__tab").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setMode(btn.getAttribute("data-d32-mode"), true);
      });
    });

    document.querySelectorAll(".d32-syscfg__select").forEach(function (sel) {
      sel.addEventListener("change", function () {
        setMode(sel.value, true);
      });
    });

    setMode(fromUrl(), false);
  }

  window.D32SyscfgBoot = boot;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  setTimeout(function () { setMode(fromUrl(), false); }, 60);
  setTimeout(function () { setMode(fromUrl(), false); }, 400);
})();


/* D32_LIVE_POLISH_INJECT */
(function(){
  if (window.__d32LivePolish) return; window.__d32LivePolish = true;
  var CSS = `
/* d32 live polish against stale page_cache skins */
[id^="TacBuilder-"], .tcb-wrap, .d32-config-wrapper, [id^="Disco32-"], .rkf-wrapper, .rkf-root, #rkfWizard {
  --tcb-bg:#eef0ee!important; --tcb-card:#fff!important; --tcb-accent:#444!important; --tcb-text:#212121!important; --tcb-border:#c5cbc5!important;
  --cat-protection:#444444!important; --cat-comms:#444444!important; --cat-interface:#444444!important; --cat-nvg:#444444!important;
  --cat-ptt:#444444!important; --cat-radio:#444444!important; --cat-aircraft:#444444!important; --cat-bluetooth:#444444!important;
  --cat-health:#444444!important; --cat-visor:#444444!important; --cat-mask:#444444!important;
  --d32-bg:#eef0ee!important; --d32-black:#eef0ee!important; --d32-card:#fff!important; --d32-panel:#fff!important;
  --d32-accent:#444444!important; --d32-text:#212121!important; --d32-ink:#212121!important; --d32-border:#c5cbc5!important;
  --d32-muted:#515151!important; --d32-sage:#c5cbc5!important; --d32-sage-bg:#f7f7f7!important;
  --rkf-bg:#eef0ee!important; --rkf-panel:#fff!important; --rkf-border:#c5cbc5!important; --rkf-text:#212121!important;
  --rkf-muted:#515151!important; --rkf-sage:#c5cbc5!important; --rkf-sage-bg:#f7f7f7!important;
  --bg:#eef0ee!important; --card:#fff!important; --border:#c5cbc5!important; --text:#212121!important; --muted:#515151!important;
  font-family: var(--font--paragraph--family, Barlow, sans-serif)!important;
  background:#eef0ee!important; color:#212121!important;
}
.tcb-wrap *, .d32-config-wrapper *, .rkf-wrapper *, #rkfWizard * { font-family: var(--font--paragraph--family, Barlow, sans-serif)!important; }
.tcb-card.selected, .tcb-card.selected * { background:#f7f7f7!important; color:#212121!important; -webkit-text-fill-color:#212121!important; border-color:#444!important; }
.tcb-btn, .d32-config-wrapper button, .rkf-wrapper button, #rkfWizard button { background:#444444!important; color:#fff!important; border-radius:2px!important; }
.tcb-wrap [style*="background: #000"], .tcb-wrap [style*="background:#000"], .tcb-wrap [style*="#0a0a0a"],
.d32-config-wrapper .bg-black, .rkf-wrapper [style*="#1a1a1a"], .rkf-wrapper [style*="#0a0a0a"] {
  background:#f7f7f7!important; background-color:#f7f7f7!important; color:#212121!important;
}
`;
  function apply(){
    var s=document.getElementById('d32-live-polish');
    if(!s){ s=document.createElement('style'); s.id='d32-live-polish'; document.documentElement.appendChild(s); }
    s.textContent=CSS;
    document.querySelectorAll('[id^="TacBuilder-"], .tcb-wrap, .d32-config-wrapper, .rkf-wrapper, #rkfWizard').forEach(function(el){
      el.style.setProperty('--cat-protection','#444444');
      el.style.background='#eef0ee';
      el.style.color='#212121';
      el.style.fontFamily='var(--font--paragraph--family, Barlow, sans-serif)';
    });
  }
  apply();
  document.addEventListener('DOMContentLoaded', apply);
  setTimeout(apply, 50); setTimeout(apply, 300); setTimeout(apply, 1000);
  document.addEventListener('click', function(){ setTimeout(apply, 30); setTimeout(apply, 200); });
})();
